export default {
  endpoint: "https://abkhaz-auto.ru/api",
  imagesBaseUrl: "https://abkhaz-auto.ru"
};
